// Builds the href for the Click-to-Call button, honoring a user's softphone preference.
const isMobileDevice = () =>
  typeof navigator !== "undefined" &&
  /Android|iPhone|iPad|iPod|Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent || "");

export const dialHref = (phone, user) => {
  const p = String(phone || "").trim();
  // On phones/tablets always use the device's native dialer so any user can tap-to-call.
  if (isMobileDevice()) return `tel:${p}`;
  const sp = (user && user.softphone) || {};
  if (!sp.enabled) return `tel:${p}`;
  const scheme = sp.scheme || "tel";
  const digits = p.replace(/[^0-9+]/g, "");
  if (scheme === "ringcentral") return `rcapp://r/call?number=${encodeURIComponent(digits)}`;
  if (scheme === "custom" && sp.template) {
    return sp.template.replace(/\{number\}/g, encodeURIComponent(digits)).replace(/\{raw\}/g, encodeURIComponent(p));
  }
  return `${scheme}:${p}`;
};

export const SOFTPHONE_SCHEMES = [
  { id: "tel", label: "Phone dialer (tel:)" },
  { id: "sip", label: "SIP softphone (sip:)" },
  { id: "callto", label: "Callto (callto:)" },
  { id: "ringcentral", label: "RingCentral" },
  { id: "custom", label: "Custom click-to-dial URL" },
];
